<template>
  <div class="row no-gutters">
    <div class="headings--h2" :class="{'col-11 col-sm-7 col-md-8' : isAuctionsCatalogLive}">
      <ArtistDetails
        v-if="artwork.artist"
        :artist="artwork.artist"/>
      <template v-else>
        {{ artwork.name }}
      </template>
    </div>
    <div v-if="isAuctionsCatalogLive" class="col-1 col-sm-5 col-md-4">
      <div class="auction__live">
        <span class="icon icon-live">
          <span class="path1"></span>
          <span class="path2"></span>
        </span>
        <span class="d-none d-sm-block">
          {{I18n.t("auctions_catalogs.live")}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
  /* global Routes */
  import ArtistDetails from '@/shared/components/artist_details';
  import { LIVE_TYPE, FINISHED_AUCTIONS_CATALOG_STATE } from '../../../consts';

  export default {
    name: 'ArtworkHeader',
    components: {
      ArtistDetails,
    },
    data() {
      return {
        finishedAuctionsCatalogState: FINISHED_AUCTIONS_CATALOG_STATE,
        auctionsCatalogLiveType: LIVE_TYPE,
        Routes,
      };
    },
    props: {
      artwork: {
        type: Object,
        required: true,
      },
    },
    computed: {
      isNotFinishedAuctionsCatalog() {
        return this.artwork.auctionsCatalog.state !== this.finishedAuctionsCatalogState;
      },
      isAuctionsCatalogLive() {
        return (this.artwork.auctionsCatalog.auctionType === this.auctionsCatalogLiveType
          && this.isNotFinishedAuctionsCatalog);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/row/artwork_header.vue?1114f3aa